<div [@routerTransition]>
  <app-page-header [heading]="'User Access'" [icon]="'fa-cogs'"></app-page-header>
  <form class="page-panel" role="form">
    <fieldset *ngIf="user_rights.APPROVE == '1'" class="form-group ">
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <label class="col-3" for="date">User Group : </label>
            <div class="col-9">
              <select (change)="getGroupAccess()" [(ngModel)]="sel_user_group"
                      class="form-control  custom-select custom-select-sm" id="sel_user_group"
                      name="sel_user_group">
                <option value="">Select User Group</option>
                <option *ngFor="let gr of user_groups"
                        value="{{ gr.USER_ACCESS_GROUP_ID }}">{{ gr.USER_ACCESS_GROUP_NAME }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="clearfix"></div>
      <table *ngIf="(user_access_list | json) != '[]'" class="table  table-bordered ">
        <tbody>
        <tr *ngFor="let module_group of user_access_list">
          <td>
            <div class="form-check">
              <label class="form-check-label">
                <input (change)="changeGroup(module_group.MODULE_GROUP_ID,!+module_group.MODULE_GROUP_ACCESS)"
                       [checked]="+module_group.MODULE_GROUP_ACCESS"
                       class="form-check-input" name="optradio"
                       type="checkbox">&nbsp;{{ module_group.MODULE_GROUP_NAME }}
              </label>
            </div>
            <ng-container *ngIf="module_group.MODULE_GROUP_ACCESS_STAGE == 5">
              <table class="sm-tbl table table-hover table-striped table-bordered">

                <thead>
                <tr>

                  <th *ngFor="let tp of user_access_types">
                    {{ tp.USER_ACCESS_TYPE_NAME }}
                  </th>
                </tr>
                </thead>
                <tbody>

                <tr [class.text-muted]="!+module_group.MODULE_GROUP_ACCESS">

                  <td *ngFor="let val of createArray(module_group.MODULE_ACCESS_RIGHTS); let i = index">
                    <input
                      (change)="changeGroupAccessRights(module_group.MODULE_GROUP_ID,!+val,i,module_group.MODULE_ACCESS_RIGHTS)"
                      [checked]="+val"
                      [disabled]="!+module_group.MODULE_GROUP_ACCESS" type="checkbox">
                  </td>
                </tr>

                </tbody>
              </table>
            </ng-container>
            <ng-container *ngIf="module_group.MODULE_GROUP_ACCESS_STAGE  != 5">
              <table class="sm-tbl table table-hover table-striped table-bordered">

                <thead>
                <tr>
                  <th>
                    Modules
                  </th>
                  <th *ngFor="let tp of user_access_types">
                    {{ tp.USER_ACCESS_TYPE_NAME }}
                  </th>
                </tr>
                </thead>
                <tbody>

                <tr *ngFor="let module of module_group.sub_menu"
                    [class.text-muted]="!+module_group.MODULE_GROUP_ACCESS">
                  <td>
                    {{ module.MODULE_NAME }}
                  </td>
                  <td *ngFor="let val of createArray(module.MODULE_ACCESS_RIGHTS); let i = index">
                    <input (change)="changeAccessRights(module.MODULE_ID,!+val,i,module.MODULE_ACCESS_RIGHTS)"
                           [checked]="+val"
                           [disabled]="!+module_group.MODULE_GROUP_ACCESS" type="checkbox">
                  </td>
                </tr>

                </tbody>
              </table>
            </ng-container>
          </td>
        </tr>
        </tbody>
      </table>
    </fieldset>
  </form>
</div>
